'use strict';

var cov_nt15kk0om = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/constants.js',
      hash = '6a986e6cd8f5bcba12b69ef354980978e4ac5d50',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/constants.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 19,
          column: 1
        }
      },
      '1': {
        start: {
          line: 21,
          column: 37
        },
        end: {
          line: 26,
          column: 1
        }
      },
      '2': {
        start: {
          line: 22,
          column: 15
        },
        end: {
          line: 25,
          column: 3
        }
      },
      '3': {
        start: {
          line: 28,
          column: 32
        },
        end: {
          line: 35,
          column: 1
        }
      },
      '4': {
        start: {
          line: 37,
          column: 37
        },
        end: {
          line: 44,
          column: 1
        }
      },
      '5': {
        start: {
          line: 46,
          column: 39
        },
        end: {
          line: 56,
          column: 3
        }
      },
      '6': {
        start: {
          line: 53,
          column: 24
        },
        end: {
          line: 56,
          column: 1
        }
      },
      '7': {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 84,
          column: 1
        }
      },
      '8': {
        start: {
          line: 86,
          column: 37
        },
        end: {
          line: 99,
          column: 1
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 15
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 7
          }
        },
        loc: {
          start: {
            line: 53,
            column: 24
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 53
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultFilterCriteria = exports.FilterField = exports.OrderProductTypeOptions = exports.OrderProductType = exports.HospitalityTypeOtions = exports.FilterActionType = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ref;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _product = require('@nucleo/product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterActionType = exports.FilterActionType = (cov_nt15kk0om.s[0]++, {
  FILTER_INITIALIZATION: 'FILTER_INITIALIZATION',
  FILTER_APPLY: 'FILTER_APPLY',
  FILTER_RESET: 'FILTER_RESET',
  FILTER_LOAD_DATA_SUCCESS: 'FILTER_LOAD_DATA_SUCCESS',
  FILTER_BAR_LOAD_DATA_ERROR: 'FILTER_LOAD_DATA_ERROR',
  FILTER_LOAD_CITY_DATA_SUCCESS: 'FILTER_LOAD_CITY_DATA_SUCCESS',
  FILTER_BAR_BEFORE_LOAD_DATA: 'FILTER_BAR_BEFORE_LOAD_DATA',
  FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS: 'FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS',
  FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS: 'FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS',
  FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS: 'FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS',
  FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS: 'FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS'
});

var HospitalityTypeOtions = exports.HospitalityTypeOtions = (cov_nt15kk0om.s[1]++, [_product.HospitalityTypeEnum.PRIVATE, _product.HospitalityTypeEnum.SHARED].map(function (hospType) {
  cov_nt15kk0om.f[0]++;
  cov_nt15kk0om.s[2]++;
  return {
    value: hospType,
    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'gravity.FilterBar.hospitalityType.' + hospType })
  };
}));

var OrderProductType = exports.OrderProductType = (cov_nt15kk0om.s[3]++, {
  PRODUCT_NAME_AZ: 'PRODUCT_NAME_AZ',
  PRODUCT_NAME_ZA: 'PRODUCT_NAME_ZA',
  LOWER_PRICE: 'LOWER_PRICE',
  HIGHER_PRICE: 'HIGHER_PRICE',
  LOWER_PRICE_PER_ATTENDEE: 'LOWER_PRICE_PER_ATTENDEE',
  HIGHER_PRICE_PER_ATTENDEE: 'HIGHER_PRICE_PER_ATTENDEE'
});

var MapOrderProductTypeWithLabel = (cov_nt15kk0om.s[4]++, (_ref = {}, (0, _defineProperty3.default)(_ref, OrderProductType.PRODUCT_NAME_AZ, 'productNameAZ'), (0, _defineProperty3.default)(_ref, OrderProductType.PRODUCT_NAME_ZA, 'productNameZA'), (0, _defineProperty3.default)(_ref, OrderProductType.LOWER_PRICE, 'lowerPrice'), (0, _defineProperty3.default)(_ref, OrderProductType.HIGHER_PRICE, 'higherPrice'), (0, _defineProperty3.default)(_ref, OrderProductType.LOWER_PRICE_PER_ATTENDEE, 'lowerPricePerPax'), (0, _defineProperty3.default)(_ref, OrderProductType.HIGHER_PRICE_PER_ATTENDEE, 'higherPricePerPax'), _ref));

var OrderProductTypeOptions = exports.OrderProductTypeOptions = (cov_nt15kk0om.s[5]++, [OrderProductType.PRODUCT_NAME_AZ, OrderProductType.PRODUCT_NAME_ZA, OrderProductType.LOWER_PRICE, OrderProductType.HIGHER_PRICE, OrderProductType.LOWER_PRICE_PER_ATTENDEE, OrderProductType.HIGHER_PRICE_PER_ATTENDEE].map(function (orderProdType) {
  cov_nt15kk0om.f[1]++;
  cov_nt15kk0om.s[6]++;
  return {
    value: orderProdType,
    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'gravity.FilterBar.orderBy.' + MapOrderProductTypeWithLabel[orderProdType] })
  };
}));

/**
 * Fitler field configuration key
 * 'site',
 * 'matchName',
 * 'team',
 * 'hospitalityType',
 * 'productName',
 * 'productLineName' = name of product inside compose product,
 * 'productTypes'= custom product type config in product level,
 * 'orderProductBy',
 */
var FilterField = exports.FilterField = (cov_nt15kk0om.s[7]++, {
  CITY: 'city',
  SITE: 'site',
  MATCH_NAME: 'matchName',
  TEAM: 'team',
  HOSPITALITY_TYPE: 'hospitalityType',
  HOSPITALITY_SESSION: 'hospitalitySessions',
  PRODUCT_NAME: 'productName',
  PRODUCT_LINE_NAME: 'productLineName',
  PRODUCT_TYPES: 'productTypes',
  ORDER_PRODUCT_BY: 'orderProductBy',
  SPACE: 'space',
  TOPIC: 'topic',
  DATE: 'date',
  PRICE: 'price'
});

var DefaultFilterCriteria = exports.DefaultFilterCriteria = (cov_nt15kk0om.s[8]++, {
  minPrice: null,
  maxPrice: null,
  fromDate: null,
  toDate: null,
  date: null,
  siteIds: null,
  teamIds: null,
  matchNames: null,
  productName: null,
  productLineName: null,
  hospProductTypes: null,
  customProducTypeIds: null
});